import React, { useEffect } from 'react';
import { ButtonGroup } from '../Button-group';
import { DropdownButton } from '../Dropdown-button';
//import { useFocusManager } from '../../Lib/FocusManager'; TODO: NOT WORKING
import { FocusScope, useFocusManager } from '@react-aria/focus'; // TODO: MAKE INTERNAL
import { Button } from '../Button';

export interface IPropTypes {
	theme?: 'primary' | 'secondary' | 'tertiary' | 'toggle' | 'tertiary-phantom' | 'toggle-phantom';
	labeledBy?: 'icon' | 'label' | 'icon-label';
	size?: 'default' | 'large' | 'compact' | 'mini';
	labelFromOptions?: boolean;
	toogleActionButton?: boolean;
	label?: string;
	icon?: React.ReactNode;
	disabled?: boolean;
	onItemSelect?: (item: any) => void;
	onClickActionButton?: (selected: boolean, actionButton: { id?: string; label?: string; icon?: React.ReactNode | boolean; }) => void;
	items: { id?: string; label?: string; icon?: React.ReactNode | boolean; custom?: any }[]; //TODO: TItem[]
	hideSelected?: boolean;
	actionButtonProps?: any;
	optionsButtonProps?: any;
}

export const SplitButton = React.forwardRef((props: IPropTypes & Omit<React.ComponentPropsWithRef<'span'>, 'css'>, ref: any) => {
	const {
		labeledBy = 'label',
		label,
		icon,
		size,
		theme = 'primary',
		labelFromOptions = false,
		toogleActionButton = false,
		hideSelected = false,
		onItemSelect,
		onClickActionButton,
		items,
		actionButtonProps,
		optionsButtonProps,
		...rest
	} = props;

	const [buttonLabel, setButtonLabel] = React.useState<{
		label?: string;
		icon?: React.ReactNode | boolean;
		id?: string;
	}>({});
	const [selected, setSelected] = React.useState(false);

	useEffect(() => {
		if (labeledBy) {
			setButtonLabel(props?.items[0] || {});
		}
	}, [labeledBy, props]);

	const _iconB: any =
		labeledBy === 'icon' || labeledBy === 'icon-label'
			? {
				iconBefore: (!icon && buttonLabel.icon) || icon,
			}
			: {};

	const _label =
		labeledBy === 'label' || labeledBy === 'icon-label' ? (!label && buttonLabel.label) || label : undefined;

	return (
		<ButtonGroup {...rest} aria-label="button-group" ref={ref} theme={theme} size={size}
			selected={selected ? [0] : []}
			onClick={(item, index) => {
				if (index === 0) {
					toogleActionButton && setSelected(!selected);
					onClickActionButton && onClickActionButton(selected, buttonLabel);
				}
			}}
			data-disabled={props?.disabled?.toString() || 'false'}
			data-labeledby={props.labeledBy}
			data-hideselected={props?.hideSelected?.toString() || 'false'}
			data-labelfromoptions={props?.labelFromOptions?.toString() || 'false'}
			data-toogleactionbutton={props?.toogleActionButton?.toString() || 'false'}
			data-theme={props.theme}
			data-size={props.size}
		>
			<Button
				{...actionButtonProps}
				isSelected={selected}
				{..._iconB}
				text={_label}
				aria-label={labeledBy == 'icon' ? _label : undefined}
			/>
			<DropdownButton
				{...optionsButtonProps}
				aria-label='Optional actions'
				buttongroupShape="last"
				styleListContainer={{
					width: '110px',
				}}
				popoverPlacement={'bottomRight'}
				icon={null as any}
				onItemSelect={({ item }: any) => {
					labelFromOptions && setButtonLabel(item);
					onItemSelect && onItemSelect(item);
				}}
				items={items.filter((val) => {
					if (props.hideSelected && val.id == buttonLabel.id) {
						return false
					}
					return true
				}) as any}

			/>
		</ButtonGroup>
	);
});
